import React from 'react';
import {HashLink as Link} from "react-router-hash-link";



export const BRfPortfolioScores ={
        url: `/board/BreachRisk/Portfolio/Details/Scores`,
        type: `tutorial`,
        user: {
            first_login: true,
            // first_time_on_page: true,
            // manager: true,
        },
        entity: {
            // verified_ownership: false,
            // subscription: "Portfolio",
            // subLevel: ["pro"],
            hasScores: null,
        },
        openingModal: {
            icon: null,
            heading: "Tour Portfolio Scores?",
            description: <div className={"text-center"}>
                <h3>

                </h3>
                <p>
                </p>

            </div>
        },
        tourSteps: {
            1: {
                step: 1,
                title: "BreachRisk™ Score",
                placement: "top",
                content: <>
                    <p>First things first, check the scores. </p>
                    <p>To learn more about how we determine your score, visit <Link smooth to={`/board/userguide`} className={"text-white "}><u>our Interactive User's Guide</u></Link>.</p>
                </>,
                scrollToElement: "#tourBRScoreDialRow",
                anchorEl: "#tourBRScoreDial",
                element: document.getElementsByClassName("tourBRScore"),
                last: false,
            },
            2: {
                step: 2,
                title: "Risk Benchmarks",
                placement: "left-start",
                content: `Risk Benchmarks allow you to compare scores to global averages. 
            Breach Risk and Breach Likelihood are key components in determining a Score and are
            broken down here to see how the likelihood of a breach and the resulting impact compare to global averages. \n`,
                anchorEl: "#tourBRRiskBenchmarks",
                scrollToElement: "#tourBRHighFidelityTesting",
                element: document.getElementsByClassName("tourWidgetBenchmarks"),
                last: false,
            },
            3: {
                step: 3,
                title: "Attack Surface Benchmarks",
                placement: "left-start",
                content:<>
                    <p>
                        Visualize how IT elements and infrastructure compare to global averages using this chart. The points plotted represent the number of each type of element found associated with this company.</p>
                    <p>
                        The company is represented by the purple shape. Hover over types to find more details.
                    </p>
                </> ,
                anchorEl: "#tourAttackSurfaceRadarChart",
                scrollToElement:"#tourBRAttackSurfaceBenchmarks",
                element: document.getElementsByClassName("tourBRAttackSurfaceBenchmarkWidget"),
                last: false,
            },
            4: {
                step: 4,
                title: "Risk Environment: Threat Vectors",
                placement: "top-end",
                content: <>
                    <p>Take a high level look at where exploitable risks rank in terms of an attacker's ability to succeed and the resulting damage.</p>
                    <p>If you have access to this company's Report, you'll be able to find more information about individual threats in <Link smooth to={`/board/BreachRisk/Business/Report/Overview`}> BreachRisk&trade; Report.</Link></p>
                    <p>To request Report access, please visit the <Link to={'/board/BreachRisk/Portfolio/Manage'} className={"text-white"}><u>Manage Portfolio Page.</u></Link></p>
                </>,
                anchorEl: "#tourPortfolioRiskCol",
                scrollToElement: "#tourBRScoreDialRow",
                element: document.getElementsByClassName("tourPortfolioRiskWidget"),
                last: false,
            },
            5: {
                step: 5,
                title: "Opportunities: Options For Attackers",
                placement: "top-end",
                content: <>
                    <p>Attackers exploit different kinds of weaknesses to breach a company's infrastructure.</p>
                    <p>This is a high level look at what kind of risks this company's infrastructure has exposed. If you have access to this company's Report, you'll be able to find more information about individual threats in <Link smooth to={`/board/BreachRisk/Business/Report/Overview`}> BreachRisk&trade; Report.</Link>
                    </p>
                    <p>To request Report access, please visit the <Link to={'/board/BreachRisk/Portfolio/Manage'} className={"text-white"}><u>Manage Portfolio Page.</u></Link></p>
                </>,
                anchorEl: "#tourPortfolioOpportunitiesCol",
                scrollToElement: "#tourBRScoreDialRow",
                element: document.getElementsByClassName("tourPortfolioOpportunitiesWidget"),
                last: false,
            },

            6: {
                step: 6,
                title: "Score History",
                content: `See how the Score has changed over time. \n`,
                anchorEl: "#tourBRScoreHistory",
                // scrollToElement: "#tourScoreDial",
                element: document.getElementsByClassName("tourBRScoreHistoryWidget"),
                last: true,
            },
            // 7: {
            //     step: 7,
            //     title: "View Individual Companies' Scores",
            //     content:<>
            //         <p>
            //             To take a look at individual companies, visit the Scores Page.
            //         </p>
            //         <p>
            //         </p>
            //     </>,
            //     anchorEl: "#tourStepBRPortfolioInsightsScores",
            //     element: document.getElementsByClassName("tourStepBRPortfolioInsightsScores"),
            //     scrollToElement: null,
            //     last: true,
            // },
        },
        style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            boxShadow: 24,
            p: 4,
        }
}
